import { render } from "./RemoveEdgeComp.vue?vue&type=template&id=a78ff7dc"
import script from "./RemoveEdgeComp.vue?vue&type=script&lang=js"
export * from "./RemoveEdgeComp.vue?vue&type=script&lang=js"

import "./RemoveEdgeComp.vue?vue&type=style&index=0&id=a78ff7dc&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__